import * as React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

interface Breadcrumb {
  title: string;
  isActive?: boolean;
  link?: string;
}

interface OwnProps {
  title: string;
  breadcrumbs: Breadcrumb[];
}

export const PageHeader = ({ title, breadcrumbs }: OwnProps) => {
  return (
    <>
      <div className="page-header mb-0">
        <h1 className="page-title">{title}</h1>
      </div>

      <div className="row mb-5">
        <div className="col-12">
          <nav aria-label="breadcrumb" className="page-breadcrumb breadcrumb">
            {breadcrumbs.map((x) => (
              <React.Fragment key={x.title}>
                {x.link ? (
                  <Link
                    to={x.link}
                    className={clsx("breadcrumb-item", {
                      active: !!x.isActive,
                    })}
                  >
                    {x.title}
                  </Link>
                ) : (
                  <span
                    className={clsx("breadcrumb-item", {
                      active: !!x.isActive,
                    })}
                  >
                    {x.title}
                  </span>
                )}
              </React.Fragment>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
};
